import { STALE_PENDING_MINUTES } from "../constants";

export default function StatusStrips({
  summaryFailedCount,
  summaryNotPublishedCount,
  stalePendingCount,
}) {
  return (
    <div className="mt-3 grid grid-cols-1 gap-2 sm:grid-cols-3">
      <div className="rounded-xl border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-800">
        Failed editions needing reupload: <span className="font-bold">{summaryFailedCount}</span>
      </div>
      <div className="rounded-xl border border-orange-200 bg-orange-50 px-3 py-2 text-sm text-orange-800">
        Not Published: <span className="font-bold">{summaryNotPublishedCount}</span>
      </div>
      <div className="rounded-xl border border-blue-200 bg-blue-50 px-3 py-2 text-sm text-blue-800">
        Pending over {STALE_PENDING_MINUTES} min: <span className="font-bold">{stalePendingCount}</span>
      </div>
    </div>
  );
}
